var map = {
	"./data-search.de-CH.json": 967,
	"./data-search.de-DE.json": 968,
	"./data-search.en-CA.json": 969,
	"./data-search.en-GB.json": 970,
	"./data-search.en-IN.json": 971,
	"./data-search.en-ME.json": 972,
	"./data-search.en-US.json": 973,
	"./data-search.es-EM.json": 974,
	"./data-search.es-ES.json": 975,
	"./data-search.fr-BE.json": 976,
	"./data-search.fr-CA.json": 977,
	"./data-search.fr-CH.json": 978,
	"./data-search.nl-BE.json": 979,
	"./data-search.nl-NL.json": 980,
	"./data-search.pl-PL.json": 981,
	"./data-search.pt-BR.json": 982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 966;